import { Component, Input } from '@angular/core';

@Component({
  selector: 'donut',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss']
})
export class Donut {
  @Input() color: string;
  @Input() textColor: string;
  @Input() rounded: boolean;
  @Input() transitions: boolean;
  @Input() skeleton: boolean;
  @Input() skeletonColor: string;

  @Input() set percentage(percentage: number) {
    this._percentage = percentage;
    this.updatePercentage();
  }

  get percentage(): number {
    return this._percentage;
  }

  @Input() set showPercentSign(showPercentSign: boolean) {
    this._showPercentSign = showPercentSign;
    this.updatePercentage();
  }

  get showPercentSign(): boolean {
    return this._showPercentSign;
  }

  _percentage: number;
  _showPercentSign: boolean;
  displayPercentage: string;
  dashoffset: string;

  constructor() {
    this.percentage = 0;
    this.showPercentSign = false;
    this.color = '#a3d3ff';
    this.textColor = 'black';
    this.rounded = true;
    this.transitions = true;
    this.skeleton = false;
    this.skeletonColor = '#eee';
  }

  updatePercentage() {
    this.displayPercentage = parseFloat((this.percentage || 0).toFixed(((this.percentage || 0) < 10 ? 1 : 0) + (this.showPercentSign ? 0 : 1))).toString() + (this.showPercentSign ? '%' : '');
    if(this.percentage == null)
      this.dashoffset = '289.027px';
    else
      this.dashoffset = (289.027 * (1 - this.percentage / 100)) + 'px';
  }
}